import { useEditorState } from "@/context/EditorStateContext";
import type { HocuspocusProvider } from "@hocuspocus/provider";
import { useMemo } from "react";

type Props = {
	yProvider: HocuspocusProvider;
};

const cursorColors = [
	"#ef4444",
	"#f97316",
	"#eab308",
	"#84cc16",
	"#14b8a6",
	"#3b82f6",
	"#8b5cf6",
	"#f43f5e",
];

export function EditorCursors({ yProvider }: Props) {
	const { awarenessUsers } = useEditorState();

	// Insert awareness info into cursors with styles
	const styleSheet = useMemo(() => {
		let cursorStyles = "";

		for (const [clientId, user] of Object.entries(awarenessUsers)) {
			if (user) {
				cursorStyles += `
          .yRemoteSelection-${clientId},
          .yRemoteSelectionHead-${clientId}  {
            --user-color: ${user.color};
          }

          .yRemoteSelectionHead-${clientId}::after {
            content: "${user.name}";
          }
        `;
			}
		}

		return { __html: cursorStyles };
	}, [awarenessUsers]);

	// biome-ignore lint/security/noDangerouslySetInnerHtml: Needed here
	return <style dangerouslySetInnerHTML={styleSheet} />;
}
